import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import cn from 'classname';
import { Link } from 'react-router';
import noop from 'lodash/noop';

const Table = ({ table, sortByColumn, pagination, gotoPage, toggleNewsOffers, deleteNews, can, intl }) =>
	<div className="table-container">
		<table className="simple-table news-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{ table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								'active': table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[table.sortedColumn.direction]: (
									table.sortedColumn.index === header.index && table.sortedColumn.direction
								)
							})}
							onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
					))}
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{table.rows.map((row, index) =>
					<tr
						key={index}
						className={cn({
							'modify-background': index % 2,
							'not-published': !row.published_at
						})}
					>
						<td className="id"><span>{row.id}</span></td>
						<td>
							<span>{getDate(row, intl)}</span>
						</td>
						<td className="modify-border title"><Link to={`/news/edit/${row.id}`}>{row.title}</Link></td>
						<td className="news_offers">
							<span>{getOffers(row, index, table.shownNewsOffers, toggleNewsOffers, intl)}</span>
						</td>
						<td className="news_offers">
							{row.news_countries && row.news_countries.length
								? (row.news_countries.map((cont, index) => <p key={index}> {cont.name} </p>))
								: 'All'
							}
						</td>
						<td className="actions">
							<Link to={`/news/edit/${row.id}`} className="action_edit" />
							{can('delete') &&
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										confirm(intl('Delete news %s?', row.title)) && deleteNews(row.id);
									}}
									className="action_delete"
								/>}
						</td>
					</tr>
				)}
			</tbody>
		</table>
		<div className="table-container__pagination">
			<div className="table-container__pagination-items">
				{pagination.pages.map(pageIndex => {
					const page = ++pageIndex;
					return (
						<a
							key={page}
							href="#"
							className={cn({
								'table-container__pagination-item': true,
								active: page === pagination.currentPage
							})}
							onClick={e => {
								e.preventDefault();
								gotoPage(page);
							}}
						>
							{page}
						</a>
					);
				})}
			</div>
		</div>
	</div>;

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	toggleNewsOffers: PropTypes.func,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	deleteNews: PropTypes.func,
	can: PropTypes.func
};

const getOffers = (row, index, shownNewsOffers, toggleNewsOffers, intl) => {
	if (!row.news_offers || !row.news_offers.length) {
		return '-';
	}
	let offers = row.news_offers.map(offer =>
		<div key={offer.id}>
			<img src={offer.image} />
			<span>{offer.title}</span>
		</div>
	);
	const offersLength = offers && offers.length;
	const doShowAllOffers = shownNewsOffers[index];

	if (offersLength && offersLength > 3) {
		offers = doShowAllOffers ? offers : offers.slice(0, 3);
		offers.push(
			<div key={offersLength + 1} className="show-all-offers" onClick={() => toggleNewsOffers(index)}>
				<span>
					{doShowAllOffers ? intl('Hide') : intl('All')}
					<span className="offers-count"> {offersLength} </span>
					{intl('offers')}
				</span>
			</div>
		);
	}

	return offers;
};

const getDate = (row, intl) => {
	const date = row.published_at || row.updated_at;
	return (
		<span>
			{moment(date).format('DD.MM.YYYY')}{' '}
			{intl('at')}{' '}
			<span className="time">{moment(date).format('HH:mm')}</span>
		</span>
	);
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/components/table/main.js